<template>
  <v-layout justify-center align-center fill-height>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
